import React, { useEffect, useState } from "react";
import { useApi } from "../context/ApiContext";
import Button from "./ui/Button";

export default function VectorForm() {
    const { apiFetch } = useApi();
    const [text, setText] = useState("");
    const [collection, setCollection] = useState("");
    const [language, setLanguage] = useState("");
    const [support, setSupport] = useState("");

    const [collections, setCollections] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [supports, setSupports] = useState([]);

    const [status, setStatus] = useState(null); // {type, text}
    const [sending, setSending] = useState(false);

    useEffect(() => {
        apiFetch("/collections").then(r => r.json()).then(j => setCollections(j.data || []));
        apiFetch("/languages").then(r => r.json()).then(j => setLanguages(j.data || []));
        apiFetch("/supports").then(r => r.json()).then(j => setSupports(j.data || []));
    }, [apiFetch]);

    const submit = async (e) => {
        e.preventDefault();
        setStatus(null);
        setSending(true);

        try {
            const res = await apiFetch("/vectors/manuel", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ text, collection, language, support }),
            });
            const json = await res.json();

            if (!res.ok || !json.success) {
                setStatus({ type: "error", text: json.error || `Erreur HTTP ${res.status}` });
                return;
            }

            setStatus({ type: "ok", text: "Texte ajouté à la mémoire." });
            setText("");
        } catch (err) {
            setStatus({ type: "error", text: "Erreur lors de l'envoi : " + err.message });
        } finally {
            setSending(false);
        }
    };

    return (
        <form onSubmit={submit} className="form-grid">
            <div className="field field--wide">
                <label htmlFor="man-text">Texte</label>
                <textarea
                    id="man-text"
                    rows={4}
                    placeholder="Texte à mémoriser…"
                    value={text}
                    onChange={e => setText(e.target.value)}
                    required
                />
            </div>

            <div className="field">
                <label htmlFor="man-collection">Collection</label>
                <select id="man-collection" value={collection}
                        onChange={e => setCollection(e.target.value)} required>
                    <option value="">—</option>
                    {collections.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
            </div>

            <div className="field">
                <label htmlFor="man-language">Langue</label>
                <select id="man-language" value={language}
                        onChange={e => setLanguage(e.target.value)} required>
                    <option value="">—</option>
                    {languages.map(l => <option key={l} value={l}>{l}</option>)}
                </select>
            </div>

            <div className="field">
                <label htmlFor="man-support">Support</label>
                <select id="man-support" value={support}
                        onChange={e => setSupport(e.target.value)} required>
                    <option value="">—</option>
                    {supports.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
            </div>

            {status && (
                <p className={`notice notice--${status.type} field--wide`}>{status.text}</p>
            )}

            <div className="form-actions">
                <Button type="submit" disabled={sending}>{sending ? "Envoi…" : "Ajouter"}</Button>
            </div>
        </form>
    );
}
